import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input, Button} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';
import { useLang } from '../../context';

const {RangePicker} = DatePicker;

export default function AcceptedBetsParlay() {
  const navigate = useNavigate();
  const location = useLocation();
  const [page,setPage] = useState(1);
  const [slips,setSlips] = useState([]);
  const [totalSlips, setTotalSlips] = useState();
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [searchName,setSearchName] = useState('');
  const [slipId,setSlipId] = useState('');
  const [date,setDate] = useState({})
  const didMount = useRef(false);
  const {text} = useLang();


  async function fetchData() {
    // if(!searchName){
    //     setErrorMsg({ info: true, msg: "First input username" })
    //     setOpenAlert(true)
    //     return
    // }
    setLoading(true)
    let res = await axios.get(`/report/getSlipByMemberName?memberName=${searchName}&slipId=${slipId}&betStatus=accepted&oddType=mix_parlay&startDate=${date.startDate} 00:00:00&endDate=${date.endDate} 23:59:59&current=${page}&pageSize=10`)

    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            setSlips([])
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setSlips(res.data.slip)
    setTotalSlips(res.data.pagination.total)
    setLoading(false)
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)
  
  const handleSearchUsername = ({currentTarget}) => setSearchName(currentTarget.value);

  const handleSearchSlipId = ({currentTarget}) => setSlipId(currentTarget.value.replace(/\s/g,''));
  
  const handleDateChange = async (v,dateString) => setDate({startDate: dateString[0],endDate: dateString[1]});

  const handleRowClick = (rowData) =>{
    navigate('/bets/betDetails?action=parlay',{state: {rowData, date, searchName, slipId}})
  }
  
  useEffect(()=> {
    if(!didMount.current){
      didMount.current = true;
      if(location?.state){
        const {date, searchName, slipId} = location.state;
        setSearchName(searchName);
        setSlipId(slipId);
        setDate(date);
      }else{
        const yesterday = moment().subtract(1,'days').format('YYYY-MM-DD');
        const tmr = moment().add(1,'days').format('YYYY-MM-DD');
        setDate({startDate: yesterday,endDate: tmr});
      }
    }else{
      fetchData()
    }
  },[searchName, date, page, slipId])

  const columns = [
      {
        title: text['Username'],
        dataIndex: 'memberName',
        key: 'id',
      },
      
      {
        title: text['Slip Id'],
        dataIndex: 'shortId',
        key: 'id',
      },
      {
        title: text['Bet Amount'],
        dataIndex: 'betAmount',
        key: 'id',
      },
      {
        title: text['Bet Date'],
        dataIndex: 'betDate',
        key: 'id',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
      {
        title: text['Odd Type'],
        key: 'id',
        dataIndex: 'betType',
      },
      {
        title: text['Bet Status'],
        key: 'id',
        dataIndex: 'betStatus',
      },
      {
        title: text['Result Status'],
        key: 'id',
        dataIndex: 'status',
      },
      {
        title: text['Action'],
        fixed: 'right',
        render: (slip) => {
          const color = `#655DBB`
          return (
          <Space size="middle">
              <Button css={css`color: black;border-color: ${color};:hover{border-color: ${color};}`} color='success' variant="outlined" >
                {text['Detail']}
              </Button>
          </Space>
        )},
      },

  ];

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div style={{display: 'flex'}}>
         <Space direction="vertical" size={12}>
          <RangePicker
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}/>
          </Space>
          <Input  placeholder={`${text['Username']}...`}  style={{width: "20%",marginLeft: "2rem"}} onChange={handleSearchUsername} value={searchName}/>
          <Input placeholder={`${text['Slip Id']}...`}  style={{width: "20%",marginLeft: "2rem"}} onChange={handleSearchSlipId} value={slipId}/>
       </div>
      <Table onRow={(rowData)=>{
        return(
          {onClick: () =>handleRowClick(rowData)}
        )
      }}
      loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={slips} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalSlips} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}


